import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLazyGetNotificationsQuery } from "store/api/investorapi/auth.api"

const useNotification = () => {
  const { userType } = useSelector((state) => state.user)
  const [getNotifications] = useLazyGetNotificationsQuery()
  const [count, setCount] = useState(0)
  const [notifications, setNotifications] = useState([])

  const getData = async () => {
    try {
      const { data, success } = await getNotifications().unwrap()

      if (success) {
        setNotifications(data.items)
        setCount(data.unread)
      }
    } catch (error) {}
  }

  useEffect(() => {
    // if (userType !== "WEALTH_PARTNER") {
    // }
    getData()
  }, [userType])

  return { notifications, count, reloadNotifications: getData }
}

export default useNotification
